import { REGISTER_STREET_TYPES } from 'constants';
import { datePicker } from 'helpers';
import { isFunction } from 'lodash';
import {
  PII_PROFILE_PERSONAL_DETAILS_DOB_FIELD,
  PII_PROFILE_PERSONAL_DETAILS_DOB_NAME,
  PII_PROFILE_PERSONAL_DETAILS_MIDDLENAME_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME,
} from '../const';

const checkDobValidation = (name, value, validation, isCheckAge) => {
  const isDobField = name === PII_PROFILE_PERSONAL_DETAILS_DOB_NAME;

  if (isDobField) {
    const { msgInvalid, msgInvalid2 } = PII_PROFILE_PERSONAL_DETAILS_DOB_FIELD;
    const dobEle = document.getElementsByName(name)[0];
    const dobValue = dobEle.value;

    if (dobEle) {
      if (dobValue.length > 0 && dobValue.length < 10) {
        validation = {
          ...validation,
          [name]: msgInvalid2,
        };
      }
    }

    if (value && isCheckAge) {
      const isOfAgeToUse = datePicker.getOfAgeToUse(value);

      if (!isOfAgeToUse) {
        validation = {
          ...validation,
          [name]: msgInvalid,
        };
      }
    }
  }

  return validation;
};

const handleFieldValidation = (
  value,
  name,
  information,
  validation,
  msgInvalid,
  checkValidFn
) => {
  if (value) {
    const isValid = isFunction(checkValidFn) && Boolean(checkValidFn(value));

    if (isValid) {
      validation = {
        ...validation,
        [name]: '',
      };
    }

    if (!isValid) {
      validation = {
        ...validation,
        [name]: msgInvalid,
      };
    }

    validation = checkDobValidation(name, value, validation, true);
  }

  return validation;
};

const handleFieldEmptyValidation = (value, name, validation, msgRequired) => {
  if (!value) {
    validation = {
      ...validation,
      [name]: msgRequired,
    };
  }

  if (name === PII_PROFILE_PERSONAL_DETAILS_MIDDLENAME_NAME) {
    validation = {
      ...validation,
      [name]: '',
    };
  }

  validation = checkDobValidation(name, value, validation);

  if (name === PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME) {
    validation = {
      ...validation,
      [name]: '',
    };
  }

  return validation;
};

export const checkFormInputValidation = (
  value,
  field,
  information,
  validation
) => {
  const { name, checkValidFn, msgInvalid, msgRequired } = field;

  validation = handleFieldEmptyValidation(value, name, validation, msgRequired);

  validation = handleFieldValidation(
    value,
    name,
    information,
    validation,
    msgInvalid,
    checkValidFn
  );

  return validation;
};

export const getAddressStreetType = (value) => {
  if (!value) return '';
  return REGISTER_STREET_TYPES.find((c) => c?.key === value);
};
